// controllers/font_size_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this._onInspect = (e) => {
            if (e.detail?.kind !== 'Text') return
            const size = e.detail?.fontSize
            if (typeof size === "number") {
                this.element.value = size
                // Tell the progress bar to update
                this.dispatch('update', {
                    bubbles: true,
                    target: this.element.parentElement.parentElement
                })
            }
        }
        document.addEventListener("ie:inspect", this._onInspect)

        this.element.addEventListener('input', (e) => {
            // 🔑 ignore programmatic events (like the one from _reflectSelectionToPanel)
            if (!e.isTrusted) return

            document.dispatchEvent(
                new CustomEvent("ie:setFontSize", { detail: { size: Number(e.target.value) } })
            )
        })
    }

    disconnect() {
        document.removeEventListener("ie:inspect", this._onInspect)
    }
}